import React from 'react';
import styled from 'styled-components';
import ColumnChart from '../../common/charts/column-chart';
import ColumnChartNav from '../../common/charts/column-chart-nav';
import FollowersChangedTooltip from './followers-changed-tooltip';
import GranularityToggle from '../../common/charts/granularity-toggle';
import { earliestStatsUnit, followersToBucket } from './transform';
import useFollowersStore from './state-hook';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export default function ChartArea() {
  const set = useFollowersStore(state => state.set);
  const followers = useFollowersStore(state => state.followers);
  const daysAgo = useFollowersStore(state => state.daysAgo);
  const granularity = useFollowersStore(state => state.granularity);
  const [bucket, setBucket] = React.useState([]);
  const initialRange = { start: Math.min(daysAgo, 30), end: 0 };
  const [dateRange, setDateRange] = React.useState({ ...initialRange });
  const [visibleRange, setVisibleRange] = React.useState({ ...initialRange });

  React.useEffect(() => {
    setBucket(followersToBucket({
      ...visibleRange,
      followers,
      granularity,
    }));
  }, [followers, granularity, visibleRange]);

  React.useEffect(() => {
    let days = daysAgo;
    if (!Number.isFinite(daysAgo)) {
      days = earliestStatsUnit({ followers, granularity });
    }
    setDateRange({ start: days, end: 0 });
    const vRange = {
      start: Number.isFinite(daysAgo) ? Math.min(30, days) : 30,
      end: 0,
    };
    setVisibleRange(vRange);
  }, [followers, granularity, daysAgo]);

  const chartProps = {
    bucket,
    granularity,
    tooltipValueContent: FollowersChangedTooltip,
  };

  const navProps = {
    granularity,
    visibleRange,
    range: dateRange,
    onPrev: () => {
      setVisibleRange({ start: visibleRange.start + 30, end: visibleRange.end + 30 });
    },
    onNext: () => {
      setVisibleRange({ start: visibleRange.start - 30, end: visibleRange.end - 30 });
    },
  };

  const gProps = {
    daysAgo,
    granularity,
    onChange: g => set(state => {
      state.granularity = g;
    }),
  };

  return (
    <Container>
      <GranularityToggle {...gProps} />
      <ColumnChart {...chartProps} />
      <ColumnChartNav {...navProps} />
    </Container>
  );
}
